var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretThin = function SvgCaretThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.894 9.5c0 .356-.12.713-.386 1.01l-7.482 7.956a.55.55 0 0 1-.742.03.55.55 0 0 1-.03-.743l7.482-7.956c.148-.149.148-.416 0-.594L.255 1.247C.047 1.039.076.712.285.505c.207-.208.534-.178.741.03L8.478 8.49c.267.296.416.653.416 1.009Z",
    fill: "#163144"
  })));
};
export default SvgCaretThin;